import React from "react";
import _ from 'lodash';
import {Formik, Field, FieldArray} from 'formik';
import {Ratio, Checkbox} from './Checkbox';
import {InputGroup, DatePicker, DateRangePicker} from "rsuite";
import moment from "moment";

export class SchedulePicker extends React.Component {

    constructor(props) {
        super(props);
    }

    addDateRange(values) {
        return () => {
            let now = new Date();
            values.dateRanges.push([new Date(now - 24 * 60 * 60 * 1000), now]);
            this.props.handleChangeState(values)
        }
    }

    removeDateRange(values, index) {
        return (e) => {
            values.dateRanges.splice(index, 1);
            this.props.handleChangeState(values)
        }
    }
    clearDateRange(values) {
        return (e) => {
            values.dateRanges = [];
            this.setState({event: values})
        }
    }

    copyDateRange(values, days, count) {
        return (e) => {
            let addDays = (date, days) => {
                var result = new Date(date);
                result.setDate(result.getDate() + days);
                return result;
            }
            var arr = []
            for(let i = 1; i <= count; i++) {
                for (var d of values.dateRanges) {
                    arr.push([addDays(d[0], i * days), addDays(d[1], i * days)])
                }
            }
            values.dateRanges = values.dateRanges.concat(arr);
            this.setState({event: values})
        }
    }

    onChangeDateRange(values, index, i) {
        return (value) => {
            values.dateRanges[index][i] = new Date(value.target.value);
            this.props.handleChangeState(values)
        }
    }

    render() {
        let values = this.props.values;
        if (!values.dateRanges)
            values.dateRanges = [];

        let handleChange = this.props.handleChange;
        let daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return (
            <div className="card mt-2">
                <a href="#pTime" className="d-block card-header" data-toggle="collapse" role="button"
                   aria-expanded="true" aria-controls="pTime">Schedule</a>
                <div className="collapse show" id="pTime">
                    <div className="card-body p-md-0 p-sm-0 px-md-2 pt-md-2">
                        <div className="row list-inline ">
                            <Ratio label="weekly"
                                   name="timeType"
                                   onChange={handleChange}
                                   value="weekly"
                                   checked={values.timeType === "weekly"}
                            />
                            <Ratio label="daterange"
                                   name="timeType"
                                   onChange={handleChange}
                                   value="daterange"
                                   checked={values.timeType === "daterange"}/>
                        </div>
                    </div>
                    {values.timeType === "weekly" &&
                    <div className="card-body p-md-3 p-sm-2">
                        <div className="alert alert-secondary mt-3">
                            Select the days of the week on which the event will be active.
                        </div>
                        <div className="row mt-2 pt-1">
                            <div className="col-xl-3 col-md-4 col-sm-5">
                                Day
                            </div>
                            <div className="col-xl-9 col-md-8 col-sm-7">
                                <div className="row">
                                    <div className="col-6 pt-1">TimeStart (hh:mm)</div>
                                    <div className="col-6 pt-1">Duration (minutes)</div>
                                </div>
                            </div>
                        </div>
                        {daysOfWeek.map((day, i) =>
                            <div key={day} className="row mt-2 pt-1">
                                <div className="col-xl-3 col-md-4 col-sm-5">
                                    <Field
                                        component={Checkbox}
                                        name={`weekly[${i}].check`}
                                        id={`weekly[${i}].check`}
                                        label={day}
                                    />
                                </div>
                                <div className="col-xl-9 col-md-8 col-sm-7">
                                    <div className="row">
                                        <div className="col-6 pt-1">
                                            <div className="form-group row pr-2">
                                                <input title="Start Time" className="form-control"
                                                       name={`weekly[${i}].time`}
                                                       type="time"
                                                       onChange={handleChange}
                                                       value={_.get(values, `weekly[${i}].time`)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6 pt-1">
                                            <div className="form-group row">
                                                <div className="l">
                                                    <input title="Duration"
                                                           className="form-control"
                                                           name={`weekly[${i}].duration`}
                                                           type="text"
                                                           onChange={handleChange}
                                                           value={_.get(values, `weekly[${i}].duration`)}/>
                                                </div>
                                                {
                                                    _.get(values, `weekly[${i}].duration`) &&
                                                    <label className="l form-text pl-1 pt-1">
                                                        {Math.floor((values.weekly[i].duration || 1440) / 60) + "h " + ((values.weekly[i].duration || 1440) % 60) + "min"}
                                                    </label>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>)
                        }
                    </div>
                    }
                    {values.timeType === "daterange" &&
                    <div className="card-body p-md-3 p-sm-2">
                        <div className="alert alert-secondary mt-3">
                            Add periods when the event should be active
                        </div>
                        {values.dateRanges && values.dateRanges.map((dateRange, dateRangeIndex) =>
                            <div key={"dr" + dateRangeIndex} className="form-group row mt-2">
                                <InputGroup style={{width: 600}}>
                                    <input type="datetime-local" value={moment(dateRange[0]).format("YYYY-MM-DDTHH:mm")} onChange={this.onChangeDateRange(values, dateRangeIndex, 0)}/>
                                    <InputGroup.Addon> - </InputGroup.Addon>
                                    <input type="datetime-local" value={moment(dateRange[1]).format("YYYY-MM-DDTHH:mm")} onChange={this.onChangeDateRange(values, dateRangeIndex, 1)}/>
                                </InputGroup>
                                <div className="col-sm-1">
                                    <button type="button"
                                            className="btn btn-outline-danger btn-circle btn-sm"
                                            onClick={this.removeDateRange(values, dateRangeIndex)}>
                                        <i className="fa fa-remove"></i>
                                    </button>
                                </div>
                            </div>)
                        }
                        <button type="button" className="btn btn-primary btn-icon btn-sm mt-3" type="button"
                                onClick={this.addDateRange(values)}>
                            <i className="fas fa-plus"></i>
                            <span className="text">Add</span>
                        </button>
                        <button type="button" className="btn btn-info btn-icon btn-sm mt-3 mr-2 " type="button"
                                onClick={this.copyDateRange(values, 2, 180)}>
                            <span className="text">Every 2</span>
                        </button>
                        <button type="button" className="btn btn-info btn-icon btn-sm mt-3 mr-2 " type="button"
                                onClick={this.copyDateRange(values, 7, 52)}>
                            <span className="text">Every 7</span>
                        </button>
                        <button type="button" className="btn btn-info btn-icon btn-sm mt-3 mr-2 " type="button"
                                onClick={this.copyDateRange(values, 14, 28)}>
                            <span className="text">Every 14</span>
                        </button>
                        <button type="button" className="btn btn-info btn-icon btn-sm mt-3 mr-2 " type="button"
                                onClick={this.copyDateRange(values, 21, 18)}>
                            <span className="text">Every 21</span>
                        </button>
                        <button type="button" className="btn btn-danger btn-icon btn-sm mt-3 mr-2 " type="button"
                                onClick={this.clearDateRange(values)}>
                            <span className="text">Clear</span>
                        </button>
                    </div>}
                </div>
            </div>
        );
    }
}